var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.133,145.067H460.8c4.71,0,8.533-3.814,8.533-8.533c0-23.526-19.14-42.667-42.667-42.667h-132.54L254.02,45.73 c-1.621-1.937-4.019-3.063-6.554-3.063H59.733C40.909,42.667,25.6,57.975,25.6,76.8v59.733 C25.6,141.252,29.423,145.067,34.133,145.067z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.867,162.133H34.133C15.309,162.133,0,177.442,0,196.267V435.2c0,18.825,15.309,34.133,34.133,34.133h443.733 c18.825,0,34.133-15.309,34.133-34.133V196.267C512,177.442,496.691,162.133,477.867,162.133z M162.133,264.533h-102.4 c-4.71,0-8.533-3.814-8.533-8.533s3.823-8.533,8.533-8.533h102.4c4.71,0,8.533,3.814,8.533,8.533 S166.844,264.533,162.133,264.533z M162.133,230.4h-102.4c-4.71,0-8.533-3.814-8.533-8.533s3.823-8.533,8.533-8.533h102.4 c4.71,0,8.533,3.814,8.533,8.533S166.844,230.4,162.133,230.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.b842c42677dbc181a1aadde9a9d95e59.svg";
export { ForwardRef as ReactComponent };